import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { IconButton, Stack, Typography } from '@mui/material';
import settings from '/@/core/settings';
import type useGeneratePDF from '/@/hooks/pdf';
import { _ } from '/@/locale';
import { isMobile, openWhatsappWeb } from '/@/utils';
import { ITEM_TYPE_LABELS, type ShareItemPopupProps } from '../index';

interface InitialStepWithoutNodesProps {
    onWhatsAppPDF?: ReturnType<typeof useGeneratePDF>['handleWhatsApp'];
    setCurrentStep: (step: number) => void;
    itemType: ShareItemPopupProps['itemType'];
}

function InitialStepWithoutNodes({ onWhatsAppPDF, setCurrentStep, itemType }: InitialStepWithoutNodesProps) {
    const itemLabel = ITEM_TYPE_LABELS[itemType];
    const handleWhatsApp = async () => {
        if (!onWhatsAppPDF) return;
        const { file } = await onWhatsAppPDF();
        if (!file) return;
        const url = (settings as any).app?.url + file?.url;
        const message = _(
            'Hola! Te envío {{itemLabel}} que generé en {{appName}}. Abrila para ver todos los detalles {{url}}',
            { itemLabel: itemLabel.singular, url, appName: settings.app.name }
        );
        if (isMobile()) {
            const encodedMessage = encodeURIComponent(message);
            window.location.href = `whatsapp://send?text=${encodedMessage}`;
        } else {
            openWhatsappWeb({ message });
        }
        setCurrentStep(2);
    };

    return (
        <Stack spacing={3} direction='column' alignItems='center' justifyContent='center'>
            <Typography variant='body1' color='primary'>
                {_('Envia {{itemLabel}} por mail o por Whatsapp', { itemLabel: itemLabel.gender })}
            </Typography>
            <Stack direction='row' spacing={2}>
                <Stack direction='column' spacing={1} alignItems='center'>
                    <IconButton onClick={handleWhatsApp} color='primary'>
                        <WhatsAppIcon sx={{ fontSize: 24 }} />
                    </IconButton>
                    <Typography variant='caption' color='primary'>
                        {_('Whatsapp')}
                    </Typography>
                </Stack>
                <Stack direction='column' spacing={1} alignItems='center'>
                    <IconButton onClick={() => setCurrentStep(1)} color='primary'>
                        <EmailOutlinedIcon sx={{ fontSize: 24 }} />
                    </IconButton>
                    <Typography variant='caption' color='primary'>
                        {_('Email')}
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
}

export default InitialStepWithoutNodes;
